import React from 'react';
import s from './s.module.less';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'constants/path';
import OptCover from './images/marketingImage.png';
import cls from 'classnames';
import usePPAChanneld from 'hooks/usePPAChanneld';

interface IProps {
    setOnboardingPopupStep: (step: number) => void;
    onClosePopup: () => void;
    isPPAProvider?: boolean;
}

const OptChannel = ({
    setOnboardingPopupStep,
    onClosePopup,
    isPPAProvider,
}: IProps) => {
    const navigate = useNavigate();
    const [ppaId, loadingPPA] = usePPAChanneld();
    return (
        <div className={s.wrap}>
            <div className={s.playerBox}>
                <div className={s.closeIcon} onClick={onClosePopup} />
                <div className={s.player}>
                    <img src={OptCover} alt="" />
                </div>
            </div>
            <div className={s.content}>

                <div className={cls(s.title, isPPAProvider && s.completeIcon)}>Start marketing your practice - help more patients connect with you</div>
                <div className={s.desc}>Opt into Klarity Health for free to attract more patients. You only need to pay when there is an appointment scheduled on your calendar.</div>
                <Button
                    className={s.stepDirBtn}
                    onClick={() => navigate(
                        `${PATH.DASHBOARD}/${PATH.CHANNEL_DETAIL}?channelId=${ppaId}`,
                    )}
                >
                    Join now
                </Button>

            </div>
            <div className={s.footer}>
                <div className={s.step}>Step 3 of 4</div>
                <div className={s.btns}>
                    <Button style={{ width: '120px' }} onClick={() => setOnboardingPopupStep(2)}>Previous</Button>
                    <Button style={{ width: '120px' }} type="primary" onClick={() => setOnboardingPopupStep(4)}>Next</Button>
                </div>
            </div>
        </div>
    );
};

export default OptChannel;
